module.exports = __webpack_public_path__ + "img/etail.c075058e.png";